import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { INVENTORY } from "../../constants/route-paths";
import { getItem, getItemStock } from "../../actions/inventory.action";
import { withRouter } from "../../util/with-router";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Table from 'react-bootstrap/Table';

// Updated OverallStock component
class OverallStock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemId: "",
      stock: {
        totalStock: 0,
        warehouseStock: 0,
        siteStock: 0
      },
    };
  }

  async componentDidMount() {
    const itemId = this.props.params.itemId;
    this.setState({ itemId });
    this.getItemStock(itemId);
  }

  getItemStock = async (itemId) => {
    this.props.getItemStock(itemId).then((response) => {
      this.setState({
        stock: response
      });
    });
  };

  cancelHandler = () => {
    this.props.history(`/${INVENTORY}`);
  };

  render() {
    const { totalStock = 0, warehouseStock = 0, siteStock = 0 } = this.state?.stock || {};

    return (
      <div className="purchase-order-block">

        <h2 className="content-heading text-uppercase">View Stock</h2>
        <div className="col-12 breadcrumb-block p-0">
          <Breadcrumb>
            <Breadcrumb.Item onClick={this.cancelHandler}>INVENTORY </Breadcrumb.Item>
            <Breadcrumb.Item active> View Stock</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="material-list-block mt-3">
          <div className="table-responsive">
            <Table bordered className="table-create table-material table-material-ch w-100">
              <thead>
                <tr>
                  <th className="w-auto">Store Location</th>
                  <th className="w-auto">Stock</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Total</td>
                  <td>{totalStock}</td>
                </tr>
                <tr>
                  <td>WareHouse</td>
                  <td>{warehouseStock}</td>
                </tr>
                <tr>
                  <td>Site</td>
                  <td>{siteStock}</td>
                </tr>
              </tbody>
            </Table>
          </div>

        </div>


      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user.userData,
});

const mapDispatchToProps = (dispatch) => ({
  getItem: bindActionCreators(getItem, dispatch),
  getItemStock: bindActionCreators(getItemStock, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OverallStock)
);
